import React from 'react';
import './../index.css';
import { Heading, ProjectCard, ProjectLayout, Section, CTA } from '../components';
import { projectData } from '../data';

const ProjectSection = () => {
  if (!projectData || Object.keys(projectData).length === 0) {
    return <div>Loading projects...</div>;
  }
  return (
    <ProjectLayout className="min-h-screen">
      {Object.values(projectData)
        .filter((project) => project?.slug) // Keeps only projects with a valid slug
        .map((project) => (
          <ProjectCard key={project?.slug} project={project} />
        ))}
    </ProjectLayout>
  );
};

const ProjectPage = () => {
  return (
    <div className="items-start">
      <Heading>Projects</Heading>
      <Section id="projects-list" className="pb-0">
        <ProjectSection />
      </Section>

      <Section id="projects-cta" className="pt-0 pb-8">
        <CTA />
      </Section>
    </div>
  );
};

export default ProjectPage;
